var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{staticClass:"vs-con-loading__container",attrs:{"id":"scheduleViewDataContainer"}},[_c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col md:w-1/2 sm:w-1/2 w-full",domProps:{"textContent":_vm._s(_vm.schedule.message)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }